import { ReactNode } from 'react';
import { Navbar } from '@/components/landing/Navbar';
import { Footer } from '@/components/landing/Footer';

export function LegalLayout({ title, children }: { title: string; children: ReactNode }) {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pt-24 pb-16">
        <div className="glass rounded-2xl p-6 sm:p-10">
          <h1 className="text-2xl sm:text-3xl font-medium mb-2">{title}</h1>
          <p className="text-sm text-muted-foreground mb-8">
            RadiologyLive.ai
          </p>
          <div className="prose prose-invert max-w-none prose-p:text-muted-foreground prose-li:text-muted-foreground prose-strong:text-foreground">
            {children}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
